export function navigate(path: string): void {
  const labels: Record<string, string> = {
    '/live': '[NAVIGATE] /live',
    '/fixtures': '[NAVIGATE] /fixtures',
    '/results': '[NAVIGATE] /results',
    '/leagues': '[NAVIGATE] /leagues',
    '/': '[NAVIGATE] /',
  };
  console.log(labels[path] ?? `[NAVIGATE] ${path}`);
  window.history.pushState({}, '', path);
  window.dispatchEvent(new PopStateEvent('popstate'));
}
